import { render, staticRenderFns } from "./NavbarComponent.vue?vue&type=template&id=4d4d5cef&scoped=true"
import script from "./NavbarComponent.vue?vue&type=script&lang=js"
export * from "./NavbarComponent.vue?vue&type=script&lang=js"
import style0 from "./NavbarComponent.vue?vue&type=style&index=0&id=4d4d5cef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4d5cef",
  null
  
)

export default component.exports